import { Component, type ReactNode } from "react"

interface Props {
  children: ReactNode
  fallback?: ReactNode
  onError?: (error: Error) => void
}

interface State {
  error: null | Error
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      error: null,
    }
  }

  static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { error }
  }

  override componentDidCatch(error: Error, info: object) {
    // eslint-disable-next-line no-console
    console.error(error, info)
    if (this.props.onError) {
      this.props.onError(error)
    }
  }

  override render() {
    if (this.state.error) {
      // Return custom callback or default error
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <div className="text-fg-red">
          {this.state.error.message ?? this.state.error.toString()}
        </div>
      )
    }

    return this.props.children
  }
}
